import { BaseModal, ModalOptions, ModalResultType } from "../../../../../core/modal/index";
import { Template } from "../../../../../core/template/index";

export default class CollectConfirmModal extends BaseModal
{
    public template = Template.lazy('/app/views/package_tracking/modals/collect_confirm/index.html');

    constructor(items: any[])
    {
        super();
        this.data.items = items;
    }

    public get defaults(): ModalOptions
    {
        return {
            title: this.pgettext('Title', 'Confirm collect')
        }
    }

    public onCancelClicked(e: Event)
    {
        this.close(ModalResultType.CANCEL);
    }

    public onSubmit(event: Event)
    {
        this.close(ModalResultType.OK);
    }
}